export default {
  getNsrQuery({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get('geo/nsr?scenarioId=' + id)
        .then((response) => {
          commit('SET_NSR_RESULTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error); })
    })
  }
}
